import React from "react";
import { Icon } from "../../../../../../elements";
import {
    IndicatorsWrapper,
    IndicatorItem,
    IndicatorItemText,
    IndicatorSeparator, NameWrapper
} from "../UserSelector.styled";

const UserIndicators = ({ userName, role, userIsActive }) => {
  return (
    <IndicatorsWrapper>
      <IndicatorItem>
        <Icon name={userIsActive ? "ellipseIndicatorActive" : "ellipseIndicatorInactive"} width="5px" height="5px" />
          <NameWrapper>
              {userName}
          </NameWrapper>
      </IndicatorItem>
      <IndicatorSeparator>
        <IndicatorItemText>{role || '------'}</IndicatorItemText>
      </IndicatorSeparator>

    </IndicatorsWrapper>
  );
};

export default UserIndicators;
